import { useEffect, useState } from "react";
import {  CaretDownOutlined, WarningOutlined, CaretRightOutlined, LineChartOutlined } from "@ant-design/icons";
import {
     ArrowLeftOutlined,
} from '@ant-design/icons';
import { DatePicker,} from 'antd';
import { useNavigate } from 'react-router-dom';
import { get } from "../Libraries/Ajax/HttpService";
import {
    Card,
    Typography,
    // Tooltip,
    Tag,
    Table,
    Space,
} from "antd";
import { Select } from 'antd';
import axios from 'axios';
import Main from "../components/layout/Main";
import Header from "../components/layout/Header";
import {
    XAxis,
    YAxis,
    CartesianGrid,
    Line,
    Tooltip,
    LineChart,
    ResponsiveContainer,
    LabelList
} from "recharts";
import back from '../assets/images/back.svg';

function TotalFlow() {
    
    const { Option } = Select;
    const [parameterthree, setParameterthree] = useState(null);
   
    const { RangePicker } = DatePicker;
    const navigate = useNavigate();
    const [data, setdata] = useState([]);
    const [loading, setloading] = useState(true);
    const onchanges = (value, dateString) => {
    
        
    
    
        setParameterthree(dateString);
        console.log(parameterthree);
      };
   
    const onRedirection = (event) => {

        navigate('/dashboard');
    }
    const onselectClicks = () => {
        navigate('/accountstats');
    }
    const onselectClick = () => {
        navigate('/account-table');
    }

      const columns = [

        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',

        },
        {
            title: 'Total Consumption(gallons)',
            dataIndex: 'override',
            key: 'override'
        },


        {
            title: 'Coefficient of variation(daily)',
            dataIndex: 'name',
            key: 'name',
        },
    ];
    useEffect(() => {
        getData()
    }
        , [])
    const getData = async () => {


        const res = await get('http://192.168.96.70:5000/apis/account/overide_name/list')
        setloading(false);
        setdata(res.data.data.account_override_list.map(row => ({ name: row.account_full_name, override: row.overided_name})));
        console.log(data);
    }
    return (
        <>
            <Header />
            <Main>
                {/* <div className="d-flex justify-content-between align-items-center">
                    <h4 className="mb-0">
                        <ArrowLeftOutlined onClick={onRedirection} /> 
                     Account Stats</h4>
                </div> */}
                        <div className="d-flex align-items-center mb-4">
                            {/* <ArrowLeftOutlined onClick={onRedirection} /> */}
                            <img src={back} alt="" style={{width:'10px', cursor: 'pointer'}} onClick={onRedirection}  />
                            <h3 className="mb-0 ms-3">Account Stats</h3>
                        </div>
                

                <div className="bottom-layout">
                    {/* <div className="layout-content"> */}

                    <div class="container-fluid pb-4 px-0 flex-column">
                        <div class="row row-cols-3 g-3">

                            <div className="col-12">


                                <Card bordered={false} className="checkStatusHealth">
                                    <div className="fs-20 fw-bold d-flex gap-3 justify-content-between align-items-center flex-wap">
                                        <div className='d-flex gap-3'>
                                            <div className="px-3 py-1 bg-white border rounded align-self-center c-pointer"
                                            onClick={onselectClicks}
                                            >
                                             <LineChartOutlined className="pe-2" />   Plot
                                            </div>
                                            <div className="px-3 py-1 text-blue bg-white border border-info rounded align-self-center c-pointer"
                                            onClick={onselectClick}
                                            > Table
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row mt-5">
                                        <div className="col-12 col-lg-12">
                                        <Table columns={columns} className="styleRemove account-table" dataSource={data} size="middle" pagination={false} />
                                        </div>
                                    </div>

                                </Card>

                            </div>
                            <br />

                            {/* </div> */}
                        </div>
                    </div>
                </div>
                <br />
                
            </Main>
        </>
    );
}
export default TotalFlow;
